import { ABOUT_IMG } from "../data/site";

const STATS = [
  { value: "75+", label: "Godina iskustva" },
  { value: "20", label: "Realiziranih projekata" },
  { value: "9", label: "Vrsta usluga" },
  { value: "1950.", label: "Tradicija od" },
];

export default function About() {
  return (
    <section
      id="o-nama"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-bg overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="text-xs uppercase tracking-widest2 text-brand flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-brand" />
              O nama
            </div>
            <h2 className="font-display font-black text-white tracking-tightest leading-[0.95] text-4xl md:text-5xl lg:text-6xl">
              Obitelj{" "}
              <span className="text-brand">Jalšovec</span>
              <br />
              i 75 godina struje.
            </h2>
            <div className="mt-8 space-y-5 text-ink-muted leading-relaxed text-base md:text-lg max-w-xl">
              <p>
                <span className="text-white font-semibold">Electris d.o.o.</span>{" "}
                član je obitelji Jalšovec s bogatom tradicijom koja seže još u
                daleku 1950. godinu. Naša tvrtka uspješno posluje na području
                Varaždina i okolice, a prema potrebi i šire.
              </p>
              <p>
                Zahvaljujući trudu i stručnosti naših električara, specijalizirani
                smo za izvođenje elektroinstalacijskih radova na poslovnim
                prostorima, stambenim zgradama i komercijalnim objektima.
              </p>
              <p>
                S ponosom najavljujemo da od prvog kvartala 2025. godine uvodimo
                u ponudu i usluge izgradnje{" "}
                <span className="text-white font-semibold">
                  solarnih elektrana
                </span>
                .
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="relative group overflow-hidden border border-white/10">
              <img
                src={ABOUT_IMG}
                alt="Profesionalni elektroinstalater na poslu"
                className="w-full h-[420px] md:h-[560px] object-cover zoom-img"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-widest2 text-brand mb-1">
                    Sjedište
                  </div>
                  <div className="font-display font-black text-2xl md:text-3xl text-white tracking-tight">
                    Varaždin, Hrvatska
                  </div>
                </div>
                <div className="hidden md:block text-right">
                  <div className="text-[10px] uppercase tracking-widest2 text-ink-muted mb-1">
                    Aktivno tržište
                  </div>
                  <div className="font-display text-white font-bold text-lg">
                    Hrvatska
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-white/10">
          {STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className={`reveal py-8 md:py-12 px-2 ${
                i < 3 ? "md:border-r border-white/10" : ""
              } ${i % 2 === 0 ? "border-r border-white/10 md:border-r" : ""}`}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="font-display font-black text-white tracking-tightest text-4xl md:text-6xl lg:text-7xl leading-none">
                {s.value}
              </div>
              <div className="mt-3 text-[10px] md:text-xs uppercase tracking-widest2 text-ink-muted">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
